/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AdminService } from './services/AdminService';
import { AdminDeviceMarketplaceService } from './services/AdminDeviceMarketplaceService';
import { AdminGatewayPaymentService } from './services/AdminGatewayPaymentService';
import { AdminTreasuryService } from './services/AdminTreasuryService';
import { CacheMonitorControllerService } from './services/CacheMonitorControllerService';
import { CategoryService } from './services/CategoryService';
import { CheckImeiService } from './services/CheckImeiService';
import { ChillpayWebhookService } from './services/ChillpayWebhookService';
import { ClaimsService } from './services/ClaimsService';
import { ClerkWebhookService } from './services/ClerkWebhookService';
import { CommissionService } from './services/CommissionService';
import { DeviceManagementService } from './services/DeviceManagementService';
import { DeviceMarketplaceService } from './services/DeviceMarketplaceService';
import { DocumentService } from './services/DocumentService';
import { DownSavingService } from './services/DownSavingService';
import { FinancierService } from './services/FinancierService';
import { FineThresholdSettingsService } from './services/FineThresholdSettingsService';
import { GatewayPaymentService } from './services/GatewayPaymentService';
import { GlobalSettingService } from './services/GlobalSettingService';
import { HistoryService } from './services/HistoryService';
import { InstallmentFinesService } from './services/InstallmentFinesService';
import { InstallmentPaymentService } from './services/InstallmentPaymentService';
import { InstallmentPlanService } from './services/InstallmentPlanService';
import { InventoryService } from './services/InventoryService';
import { LiffService } from './services/LiffService';
import { LiffFinancierService } from './services/LiffFinancierService';
import { LiffShopService } from './services/LiffShopService';
import { LineOaFinancierService } from './services/LineOaFinancierService';
import { LineOaFinancierWebhookControllerService } from './services/LineOaFinancierWebhookControllerService';
import { LineOaShopService } from './services/LineOaShopService';
import { LineOaShopWebhookControllerService } from './services/LineOaShopWebhookControllerService';
import { LineShopLinkTokenService } from './services/LineShopLinkTokenService';
import { LineWebhookControllerService } from './services/LineWebhookControllerService';
import { LoanRegistrationService } from './services/LoanRegistrationService';
import { LocationService } from './services/LocationService';
import { MonetaryService } from './services/MonetaryService';
import { NotificationService } from './services/NotificationService';
import { OrderService } from './services/OrderService';
import { PartnerDownSavingsService } from './services/PartnerDownSavingsService';
import { PartnerInstallmentsService } from './services/PartnerInstallmentsService';
import { PartnerProfilesService } from './services/PartnerProfilesService';
import { ProfileService } from './services/ProfileService';
import { PublicService } from './services/PublicService';
import { PublicSocialLinksService } from './services/PublicSocialLinksService';
import { ReferralService } from './services/ReferralService';
import { ReportService } from './services/ReportService';
import { ShopService } from './services/ShopService';
import { ShopPawningCreationService } from './services/ShopPawningCreationService';
import { ShopPawningReportService } from './services/ShopPawningReportService';
import { ShopPawningTransactionService } from './services/ShopPawningTransactionService';
import { ShopProductsService } from './services/ShopProductsService';
import { ShopQuotasService } from './services/ShopQuotasService';
import { ShopSettingsService } from './services/ShopSettingsService';
import { ShopSourcesService } from './services/ShopSourcesService';
import { SlipVerificationsService } from './services/SlipVerificationsService';
import { SocialLinkControllerService } from './services/SocialLinkControllerService';
import { SocialSettingControllerService } from './services/SocialSettingControllerService';
import { SupportCaseService } from './services/SupportCaseService';
import { SupportCaseCommentService } from './services/SupportCaseCommentService';
import { TokenService } from './services/TokenService';
import { TreasuryService } from './services/TreasuryService';
import { UserService } from './services/UserService';
import { ValuedCustomerCaseControllerService } from './services/ValuedCustomerCaseControllerService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class BackendApiClient {
    public readonly admin: AdminService;
    public readonly adminDeviceMarketplace: AdminDeviceMarketplaceService;
    public readonly adminGatewayPayment: AdminGatewayPaymentService;
    public readonly adminTreasury: AdminTreasuryService;
    public readonly cacheMonitorController: CacheMonitorControllerService;
    public readonly category: CategoryService;
    public readonly checkImei: CheckImeiService;
    public readonly chillpayWebhook: ChillpayWebhookService;
    public readonly claims: ClaimsService;
    public readonly clerkWebhook: ClerkWebhookService;
    public readonly commission: CommissionService;
    public readonly deviceManagement: DeviceManagementService;
    public readonly deviceMarketplace: DeviceMarketplaceService;
    public readonly document: DocumentService;
    public readonly downSaving: DownSavingService;
    public readonly financier: FinancierService;
    public readonly fineThresholdSettings: FineThresholdSettingsService;
    public readonly gatewayPayment: GatewayPaymentService;
    public readonly globalSetting: GlobalSettingService;
    public readonly history: HistoryService;
    public readonly installmentFines: InstallmentFinesService;
    public readonly installmentPayment: InstallmentPaymentService;
    public readonly installmentPlan: InstallmentPlanService;
    public readonly inventory: InventoryService;
    public readonly liff: LiffService;
    public readonly liffFinancier: LiffFinancierService;
    public readonly liffShop: LiffShopService;
    public readonly lineOaFinancier: LineOaFinancierService;
    public readonly lineOaFinancierWebhookController: LineOaFinancierWebhookControllerService;
    public readonly lineOaShop: LineOaShopService;
    public readonly lineOaShopWebhookController: LineOaShopWebhookControllerService;
    public readonly lineShopLinkToken: LineShopLinkTokenService;
    public readonly lineWebhookController: LineWebhookControllerService;
    public readonly loanRegistration: LoanRegistrationService;
    public readonly location: LocationService;
    public readonly monetary: MonetaryService;
    public readonly notification: NotificationService;
    public readonly order: OrderService;
    public readonly partnerDownSavings: PartnerDownSavingsService;
    public readonly partnerInstallments: PartnerInstallmentsService;
    public readonly partnerProfiles: PartnerProfilesService;
    public readonly profile: ProfileService;
    public readonly public: PublicService;
    public readonly publicSocialLinks: PublicSocialLinksService;
    public readonly referral: ReferralService;
    public readonly report: ReportService;
    public readonly shop: ShopService;
    public readonly shopPawningCreation: ShopPawningCreationService;
    public readonly shopPawningReport: ShopPawningReportService;
    public readonly shopPawningTransaction: ShopPawningTransactionService;
    public readonly shopProducts: ShopProductsService;
    public readonly shopQuotas: ShopQuotasService;
    public readonly shopSettings: ShopSettingsService;
    public readonly shopSources: ShopSourcesService;
    public readonly slipVerifications: SlipVerificationsService;
    public readonly socialLinkController: SocialLinkControllerService;
    public readonly socialSettingController: SocialSettingControllerService;
    public readonly supportCase: SupportCaseService;
    public readonly supportCaseComment: SupportCaseCommentService;
    public readonly token: TokenService;
    public readonly treasury: TreasuryService;
    public readonly user: UserService;
    public readonly valuedCustomerCaseController: ValuedCustomerCaseControllerService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://localhost:8080',
            VERSION: config?.VERSION ?? '2',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.admin = new AdminService(this.request);
        this.adminDeviceMarketplace = new AdminDeviceMarketplaceService(this.request);
        this.adminGatewayPayment = new AdminGatewayPaymentService(this.request);
        this.adminTreasury = new AdminTreasuryService(this.request);
        this.cacheMonitorController = new CacheMonitorControllerService(this.request);
        this.category = new CategoryService(this.request);
        this.checkImei = new CheckImeiService(this.request);
        this.chillpayWebhook = new ChillpayWebhookService(this.request);
        this.claims = new ClaimsService(this.request);
        this.clerkWebhook = new ClerkWebhookService(this.request);
        this.commission = new CommissionService(this.request);
        this.deviceManagement = new DeviceManagementService(this.request);
        this.deviceMarketplace = new DeviceMarketplaceService(this.request);
        this.document = new DocumentService(this.request);
        this.downSaving = new DownSavingService(this.request);
        this.financier = new FinancierService(this.request);
        this.fineThresholdSettings = new FineThresholdSettingsService(this.request);
        this.gatewayPayment = new GatewayPaymentService(this.request);
        this.globalSetting = new GlobalSettingService(this.request);
        this.history = new HistoryService(this.request);
        this.installmentFines = new InstallmentFinesService(this.request);
        this.installmentPayment = new InstallmentPaymentService(this.request);
        this.installmentPlan = new InstallmentPlanService(this.request);
        this.inventory = new InventoryService(this.request);
        this.liff = new LiffService(this.request);
        this.liffFinancier = new LiffFinancierService(this.request);
        this.liffShop = new LiffShopService(this.request);
        this.lineOaFinancier = new LineOaFinancierService(this.request);
        this.lineOaFinancierWebhookController = new LineOaFinancierWebhookControllerService(this.request);
        this.lineOaShop = new LineOaShopService(this.request);
        this.lineOaShopWebhookController = new LineOaShopWebhookControllerService(this.request);
        this.lineShopLinkToken = new LineShopLinkTokenService(this.request);
        this.lineWebhookController = new LineWebhookControllerService(this.request);
        this.loanRegistration = new LoanRegistrationService(this.request);
        this.location = new LocationService(this.request);
        this.monetary = new MonetaryService(this.request);
        this.notification = new NotificationService(this.request);
        this.order = new OrderService(this.request);
        this.partnerDownSavings = new PartnerDownSavingsService(this.request);
        this.partnerInstallments = new PartnerInstallmentsService(this.request);
        this.partnerProfiles = new PartnerProfilesService(this.request);
        this.profile = new ProfileService(this.request);
        this.public = new PublicService(this.request);
        this.publicSocialLinks = new PublicSocialLinksService(this.request);
        this.referral = new ReferralService(this.request);
        this.report = new ReportService(this.request);
        this.shop = new ShopService(this.request);
        this.shopPawningCreation = new ShopPawningCreationService(this.request);
        this.shopPawningReport = new ShopPawningReportService(this.request);
        this.shopPawningTransaction = new ShopPawningTransactionService(this.request);
        this.shopProducts = new ShopProductsService(this.request);
        this.shopQuotas = new ShopQuotasService(this.request);
        this.shopSettings = new ShopSettingsService(this.request);
        this.shopSources = new ShopSourcesService(this.request);
        this.slipVerifications = new SlipVerificationsService(this.request);
        this.socialLinkController = new SocialLinkControllerService(this.request);
        this.socialSettingController = new SocialSettingControllerService(this.request);
        this.supportCase = new SupportCaseService(this.request);
        this.supportCaseComment = new SupportCaseCommentService(this.request);
        this.token = new TokenService(this.request);
        this.treasury = new TreasuryService(this.request);
        this.user = new UserService(this.request);
        this.valuedCustomerCaseController = new ValuedCustomerCaseControllerService(this.request);
    }
}

